const BREAKPOINT = 768;

const addResizeListener = () => {
  const onWindowResize = () => {
    if (window.innerWidth >= BREAKPOINT) {
      document.documentElement.classList.remove('show-nav');
      window.removeEventListener('resize', onWindowResize);
    }
  }

  window.addEventListener('resize', onWindowResize);
};

export default addResizeListener;
